export default __webpack_public_path__ + "static/media/02_tap.696fda7b.png";